import api from './api';

export const getChats = (params) => api.get('/chats', { params });
export const createChat = (data) => api.post('/chats', data);
export const updateChat = (id, data) => api.put(`/chats/${id}`, data);
export const deleteChat = (id) => api.delete(`/chats/${id}`);
export const getChatMessages = (chatId, params) => api.get(`/chats/${chatId}/messages`, { params });
export const sendChatMessage = (chatId, data) => api.post(`/chats/${chatId}/messages`, data);
export const deleteChatMessage = (chatId, messageId) =>
  api.delete(`/chats/${chatId}/messages/${messageId}`);
export const markChatRead = (chatId) => api.post(`/chats/${chatId}/read`);
